module.exports = __webpack_public_path__ + "static/media/SadFace-2x.7cbcd0c7.png";